import React, {useRef, useState} from 'react';
import parsePhoneNumber from 'libphonenumber-js';
import * as R from 'ramda';
import { useHistory, useLocation } from 'react-router-dom';
import {GenerateOtpCode, ValidatePhoneNumber} from '../../../../actions/auth/partnersInvitation';

export const PartnerInvitationStep1 = ({user, timestamp, nonce, signature}) => {
    const history = useHistory();
    const location = useLocation();
    const formRef = useRef();
    const [loadings, setLoadings] = useState([]);
    const [otpCode, setOtpCode] = useState({
        code: "",
        isValidated: false
    });
    const parsedPhoneNumber = parsePhoneNumber(user.phoneNumber);
    return (
        <>
        <form className="container-xl-base py-2 mb-auto" noValidate ref={formRef}>
            <h1 className="h1 text-primary font-weight-bolder mb-6">Activation de votre compte</h1>
            <div className="form-group container-wide">
                <label className="h6 font-weight-bolder lh-copy" htmlFor="code">Nous venons d'envoyer un code de validation par SMS au<br /><span className="text-primary fs-root">
                    {R.isNil(parsedPhoneNumber) ? '' : parsedPhoneNumber.formatInternational()}
                    </span>{ otpCode.isValidated ? <span className="badge badge-pill badge-success align-middle ml-2 pill">Validé</span> : ""}</label>

                {
                    otpCode.isValidated ?
                        ''
                    :
                        <>
                        <div className="input-group has-validation mb-0">
                            <input type="text" id="otpCodeInput" required className="form-control border-common rounded bi-none" placeholder="Saisissez le code reçu" aria-describedby="codeHelpBlock" value={otpCode.code}
                                onInput={(e) => {
                                    formRef.current.classList.remove('was-validated');
                                    document.getElementById("otpCodeInput").setCustomValidity("");
                                    setOtpCode({...otpCode, code:e.target.value});
                                }}/>
                            <span className="input-group-text p-0 ml-1 border-none rounded-sm bg-none">
                                {
                                    loadings.includes("VALIDATING_OTP") ?
                                        <button type="button" className="btn btn-info rounded loading-btn show"><div className="loading loading-spinner spinner-border spinner-border-sm mr-2"></div>Valider</button>
                                    :
                                        <button type="button" className="btn btn-info rounded" onClick={(e) => {
                                        e.preventDefault();
                                        if(formRef.current.checkValidity()){
                                            ValidatePhoneNumber(user.userId, timestamp, nonce, signature, otpCode.code, user.phoneNumber)
                                            .then(() => setOtpCode({...otpCode, isValidated:true}))
                                            .catch((e) => {
                                                document.getElementById("otpCodeInput").setCustomValidity("Le code n'est pas valide. Veuillez réssayer.")
                                                document.getElementById("OtpCodeInputValidation").innerHTML = document.getElementById("otpCodeInput").validationMessage;
                                            });
                                            
                                        }
                                        formRef.current.classList.add('was-validated');
                                        }}>Valider</button>
                                }
                                {/* <button type="button" className="btn btn-white-light rounded ml-1" onClick={(e) => {
                                    e.preventDefault();                                                            
                                    setCredentials({ ...credentials, otpCode: '' });
                                    setEditPhoneNumberStep(1);
                                }}>Annuler</button> */}
                            </span>
                            <div className={"invalid-feedback"}>
                                <i className="eva eva-alert-triangle-outline text-danger mr-1 fs-sm lh-root align-middle"></i>
                                <span className="align-middle text-dark o-70" id="OtpCodeInputValidation">Le code n'est pas valide. Veuillez réssayer.</span>
                            </div>

                        </div>
                        
                        {
                            loadings.includes("SENDING_OTP") ?
                                <div className="block fs-3 w-100 mt-2">
                                    <div className="spinner-border spinner-border-sm text-primary mr-1" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                    <span className="align-middle text-dark o-70">Veuillez patienter...</span>
                                </div>
                            :
                                <p className="form-text small text-gray mt-2" id="codeHelpBlock">Vous ne l'avez pas reçu ? <span role="button" className="text-primary o-70--hover align-middle font-weight-bold" onClick={(e) => {
                                    e.preventDefault();
                                    setLoadings([...loadings, "SENDING_OTP"]);
                                    GenerateOtpCode(user.userId, timestamp, nonce, signature, user.phoneNumber)
                                    .then(() => {
                                        setLoadings(loadings.filter(l => l !== "SENDING_OTP"));
                                    });
                                    document.getElementById("otpCodeInput").setCustomValidity("");

                                }}>En recevoir un nouveau</span></p>
                        }
                        </>
                }
                
            </div>
        </form>
        <footer className="block mt-auto text-left w-100 rounded-inherit">
            <button onClick={(e) => history.push(`/auth/partner/invitation/${user.userId}/activation/step0${location.search}`)} className="btn btn-faded px-md-gutter mr-3">Retour</button>
            <button className="btn btn-primary px-md-gutter px-4" disabled={!otpCode.isValidated} onClick={(e) => history.push(`/auth/partner/invitation/${user.userId}/activation/step2${location.search}`)}>Suivant</button>
        </footer>
    </>
    )
}